var tag = document.createElement('script'); 
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);


var ytPlayers = [];
var player;

function onYouTubePlayerAPIReady() {
    var ytIframeDivs = document.getElementsByClassName('ytplayer');
    if (ytIframeDivs.length > 0) {
        Array.prototype.forEach.call(ytIframeDivs, ytIframeDiv => {
            let vidId =  ytIframeDiv.dataset.vidid;
            let ytIframeId = 'ytplayer' + vidId;
            let playlist = ytIframeDiv.dataset.playlist;
            if (playlist == '') {
                playlist = vidId;
            }
            ytPlayers[ytIframeId] = new YT.Player(ytIframeId, {
                videoId: vidId,
                host: 'https://www.youtube-nocookie.com',
                playerVars: {
                    controls: ytIframeDiv.dataset.controls,
                    autoplay: ytIframeDiv.dataset.autoplay,
                    mute: ytIframeDiv.dataset.mute,
                    rel: ytIframeDiv.dataset.rel,
                    loop: ytIframeDiv.dataset.loop,
                    playlist: playlist,
                    playsinline: 1
                },
                events: {
                    'onReady': onPlayerReady,
                }
            });
        });
    }
}

function onPlayerReady(event) {
    ytPlayers['ytplayer' + vidId] = event.target;
    var vidId = event.target.i.h.videoId;
    if (vidId == null || vidId == '') {
        vidId = event.target.h.id;
        vidId = vidId.replace('ytplayer', '');
    }
    var autoplay = event.target.h.dataset.autoplay; 

    if (autoplay == 1) {
        $('#playBtn' + vidId).trigger('click');
    }
}

function playYouTubePlayer(playerKey, initialPlay = false, time = 0) {
    if (!initialPlay) {
        ytPlayers[playerKey].stopVideo();
        ytPlayers[playerKey].seekTo(time, false);
    }
    ytPlayers[playerKey].playVideo();
    if (ytPlayers[playerKey].getPlayerState() != 1) {
        setTimeout(function() {
            ytPlayers[playerKey].playVideo();
        }, 3000);
    }
}

function stopYouTubePlayer(playerKey) {
    ytPlayers[playerKey].stopVideo();
    ytPlayers[playerKey].seekTo(0, false);
}


function stopAllYouTubeVideos() {
    ytPlayers.forEach(ytPlayer => {
        ytPlayer.stopVideo();
        ytPlayer.seekTo(0, false);
    });
}